import { render } from "./QueueNavigator.vue?vue&type=template&id=2dec7293&scoped=true&ts=true"
import script from "./QueueNavigator.vue?vue&type=script&lang=ts"
export * from "./QueueNavigator.vue?vue&type=script&lang=ts"

import "./QueueNavigator.vue?vue&type=style&index=0&id=2dec7293&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dec7293"]])

export default __exports__